var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAgeTwelvePlus = function SvgAgeTwelvePlus(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 15,
    x: 0.5,
    y: 0.5,
    fill: "inherit",
    stroke: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.398 12v-1.047l2.777-2.723q.398-.402.664-.714.266-.313.398-.606.133-.292.133-.625a1.2 1.2 0 0 0-.172-.648 1.14 1.14 0 0 0-.472-.422 1.5 1.5 0 0 0-.684-.149q-.395 0-.691.164a1.13 1.13 0 0 0-.461.457 1.5 1.5 0 0 0-.16.708h-1.38q0-.762.348-1.325t.957-.87q.614-.31 1.406-.31.805 0 1.415.301.608.3.945.825.34.523.34 1.195 0 .45-.172.883-.172.434-.606.96-.429.528-1.207 1.278l-1.378 1.402v.055h3.484V12zm-2.032-8v8h-1.449V5.41h-.047L12 6.605V5.277L13.987 4zm-8.28 6.719V5.313h1.226v5.406zm-2.09-2.09V7.402h5.406V8.63z"
  })));
};
export default SvgAgeTwelvePlus;